import { createContext, useContext } from 'react';
import { DEFAULT_REDUCED_MOTION_PREFERENCE, type ReducedMotionPreference } from './motion-preference';

/** The player's reduced motion choice. Without a `WordsHappenMotionProvider`, motion follows the device. */
export const MotionPreferenceContext = createContext<ReducedMotionPreference>(DEFAULT_REDUCED_MOTION_PREFERENCE);

/** The player's reduced motion choice from the nearest `WordsHappenMotionProvider`, or `system` without one. */
export const useMotionPreference = (): ReducedMotionPreference => useContext(MotionPreferenceContext);
